import React from 'react';
import { ChartFormItemKey } from '@tencent/chart-drawer-components/lib/schema';
import { FormItemLabelName, FormItemType } from '@framework/workbench/drawer/constants';
import i18n from '@i18next/i18n';
import type { FormConfig } from '@tencent/wb-ext-form';
import { LINEAR_GRADIENT_ICON, RADIAL_GRADIENT_ICON } from '@src/framework/editor/src/img/pageIndex';
import {
    buttonStyle,
    iconStyle,
    textStyle,
    angleStyle,
    selectStyle,
} from '@framework/workbench/drawer/ui/fill/constants';
import { AngleOptions, COLOR_STYLE, OpacityOptions } from '@src/framework/workbench/drawer/common/config';
import { DirectOptions } from '../../common/fill/config';


export const colorBgID = 'palette-color-bg-id2';
export const colorIconID = 'palette-color-icon-id2';
export const WIDTH_MAX = 50;

export const DrawerBorderType = {
    NO_SELECT: '-1', // 无选择，用于多选
    NO_FILL: '1',    // 无边框
    SOLID_FILL: '2', // 纯色边框
    GRAD_FILL: '3',  // 渐变色边框
};

export const BorderTypes = [
    { key: DrawerBorderType.NO_FILL, content: i18n.t('无边框') },
    { key: DrawerBorderType.SOLID_FILL, content: i18n.t('纯色边框') },
    { key: DrawerBorderType.GRAD_FILL, content: i18n.t('渐变色边框') },
];

export const FORM_CONFIGS: FormConfig[] = [
    {
        type: FormItemType.SELECT,
        name: ChartFormItemKey.CHART_GLOBAL_LINE_SELECT,
        options: {
            selectOptions: BorderTypes,
        },
    },
    {
        type: FormItemType.CUSTOM,
        name: ChartFormItemKey.CHART_GLOBAL_LINE,
        content: '',
    },
    {
        type: FormItemType.SPIN,
        name: ChartFormItemKey.CHART_GLOBAL_LINE_WIDTH,
        options: {
            step: 0.25,
            min: 0,
            max: WIDTH_MAX,
            allowDecimal: true,
            maxLength: 5,
            toFixed: 2,
        },
        style: {
            minWidth: 72,
        },
        defaultValue: 0,
    },
    {
        type: FormItemType.CUSTOM,
        name: ChartFormItemKey.CHART_GLOBAL_LINE_COLOR,
        options: {
        },
        style: COLOR_STYLE,
    },
    {
        type: FormItemType.SLIDER,
        name: ChartFormItemKey.CHART_GLOBAL_LINE_OPACITY,
        label: FormItemLabelName.OPACITY,
        options: {
            ...OpacityOptions,
        },
        defaultValue: 0,
    },
    {
        type: FormItemType.CUSTOM,
        name: ChartFormItemKey.CHART_GLOBAL_LINE_SPACE,
        content: '',
        style: {
            flex: 1,
            width: 'min-content',
            maxWidth: '16px',
            margin: '0 !important',
        },
    },
    {
        type: FormItemType.BUTTON,
        name: ChartFormItemKey.CHART_GLOBAL_LINE_GRADUAL_LINEAR_GRADIENT,
        options: {
            icon: <img src={LINEAR_GRADIENT_ICON} alt={''} style={iconStyle}/>,
        },
        tooltip: i18n.t('线性'),
        style: buttonStyle,
    },
    {
        type: FormItemType.BUTTON,
        name: ChartFormItemKey.CHART_GLOBAL_LINE_GRADUAL_RADIAL_GRADIENT,
        options: {
            icon: <img src={RADIAL_GRADIENT_ICON} alt={''} style={iconStyle}/>,
        },
        tooltip: i18n.t('射线'),
        style: buttonStyle,
    },
    {
        type: FormItemType.ANGLE,
        name: ChartFormItemKey.CHART_GLOBAL_LINE_GRADUAL_ANGLE,
        options: {
            ...AngleOptions,
            maxLength: 4,
        },
        style: angleStyle,
        defaultValue: 0,
    },
    {
        type: FormItemType.SELECT,
        name: ChartFormItemKey.CHART_GLOBAL_LINE_GRADUAL_DIRECTION,
        options: {
            selectOptions: DirectOptions,
            style: {
                fontSize: 12,
            },
        },
        style: selectStyle,
        tooltip: i18n.t('方向'),
    },
    {
        type: FormItemType.CUSTOM,
        name: ChartFormItemKey.CHART_GLOBAL_LINE_GRADUAL_BAR,
        content: '',
    },
    {
        type: FormItemType.SLIDER,
        name: ChartFormItemKey.CHART_GLOBAL_LINE_GRADUAL_OPACITY,
        label: FormItemLabelName.OPACITY,
        options: {
            ...OpacityOptions,
        },
        defaultValue: 0,
    },
    {
        name: ChartFormItemKey.CHART_GLOBAL_LINE_GRADUAL_TYPE_TEXT,
        type: FormItemType.TEXT,
        value: i18n.t('类型'),
        style: textStyle,
    },
    {
        name: ChartFormItemKey.CHART_GLOBAL_LINE_GRADUAL_DIRECTION_TEXT,
        type: FormItemType.TEXT,
        value: i18n.t('方向'),
        style: textStyle,
    },
    {
        name: ChartFormItemKey.CHART_GLOBAL_LINE_GRADUAL_ANGLE_TEXT,
        type: FormItemType.TEXT,
        value: i18n.t('角度'),
        style: textStyle,
    },
];
